/* ==========================================================================
   tunca-custom.js: foglio unico degli script CBD Bob (tema Savor)
   Richiamato da un solo punto: sezione Custom Liquid nel gruppo header.
   Regole: vedi PIANO-MIGRAZIONE.md sezione 1b.
   ========================================================================== */

/* Verifica età 18+ (markup in snippets/tunca-age-gate.liquid, stili in tunca-custom.css).
   Lo script inline dello snippet decide prima del paint se mostrare il dialogo
   (classe tunca-age-open su <html>); qui ci sono solo i pulsanti. */
(function () {
  'use strict';

  var KEY = 'tunca_age_ok';
  var root = document.documentElement;

  function init() {
    var gate = document.getElementById('tunca-age');
    if (!gate) return;

    if (window.Shopify && window.Shopify.designMode) {
      root.classList.remove('tunca-age-open');
      return;
    }

    var yes = gate.querySelector('[data-tunca-age="yes"]');
    var no = gate.querySelector('[data-tunca-age="no"]');
    var actions = gate.querySelector('.tunca-age__actions');
    var denied = document.getElementById('tunca-age-denied');
    if (!yes || !no || !actions || !denied) return;

    function save() {
      var value = String(Date.now());
      try {
        localStorage.setItem(KEY, value);
      } catch (e) {
        try {
          sessionStorage.setItem(KEY, value);
        } catch (e2) {}
      }
    }

    yes.addEventListener('click', function () {
      save();
      root.classList.remove('tunca-age-open');
    });

    no.addEventListener('click', function () {
      actions.hidden = true;
      denied.hidden = false;
      denied.focus();
    });

    /* Focus tenuto dentro al dialogo finché è aperto */
    gate.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab' || !root.classList.contains('tunca-age-open')) return;
      var buttons = Array.prototype.filter.call(gate.querySelectorAll('button'), function (button) {
        return !button.closest('[hidden]');
      });
      if (!buttons.length) {
        event.preventDefault();
        return;
      }
      var first = buttons[0];
      var last = buttons[buttons.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    if (root.classList.contains('tunca-age-open')) yes.focus();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Pagina 404: chi arriva da un vecchio link o da Google su un URL che non esiste più
   (prodotto archiviato, pagina nascosta) viene portato alla home nella sua lingua.
   Il server risponde comunque 404 e i bot (user agent) non vengono reindirizzati, così i
   motori di ricerca vedono la 404 vera e tolgono la pagina dall'indice. Nessun redirect
   nell'editor del tema e nelle anteprime. Se l'URL torna valido (prodotto riattivato) la
   pagina non è più 404 e questo codice non si attiva. */
(function () {
  'use strict';

  var main = document.getElementById('MainContent');
  if (!main || main.getAttribute('data-template') !== '404') return;

  var shopify = window.Shopify || {};
  if (shopify.designMode || shopify.visualPreviewMode) return;

  var agent = navigator.userAgent || '';
  if (navigator.webdriver) return;
  if (/bot|crawl|spider|slurp|mediapartners|lighthouse|pagespeed|headless|facebookexternalhit|preview|inspectiontool/i.test(agent)) return;

  var home = (shopify.routes && shopify.routes.root) || '/';
  if (location.pathname === home || location.pathname + '/' === home) return;

  location.replace(home);
})();
